// The dataLayer contract. This file doubles as the spec for whoever owns the GTM
// container: these are the event names and payload shapes tags should trigger on.
//
// Note for the container owner: pageview tags must trigger on `bou_page_view`,
// NOT GTM's built-in All Pages trigger, or the initial view double-counts against
// our own push.

export const PAGE_VIEW = "bou_page_view";
export const EXPERIMENT_VIEW = "bou_experiment_view";
export const CTA_CLICK = "bou_cta_click";

/** "initial" is the document load; "spa" is every client-side navigation after it. */
export type NavigationType = "initial" | "spa";

export interface PageViewEvent {
  event: typeof PAGE_VIEW;
  page_path: string;
  page_title: string;
  navigation_type: NavigationType;
}

export interface ExperimentViewEvent {
  event: typeof EXPERIMENT_VIEW;
  experiment_id: string;
  variant_id: string;
  /** True when pinned via `?ab=`. Analysts filter these out first. */
  is_forced: boolean;
}

export interface CtaClickEvent {
  event: typeof CTA_CLICK;
  cta_id: string;
  cta_text?: string;
  cta_location?: string;
}

export type AnalyticsEvent = PageViewEvent | ExperimentViewEvent | CtaClickEvent;
